import { useState, useCallback } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { getActiveTags } from './Services/TagService';
import { getActiveCourses } from './Services/ContentService';
import { updateContent } from './Services/ContentManagerService';
import { API_BASE_URL, API_ROOT } from '../../../../../../../../../Helpers/apiConfig';

// Choice/Link/Sentence/TrueFalse/RealMatch/Write dosyalarında birebir aynı olan
// tag/kurs listesi çekme, genel güncelleme ve soru medyası yönetimi mantığı.
const useQuestionEditorShared = (props, user) => {
    const [msg, setMsg] = useState([]);
    const [tags, setTags] = useState([]);
    const [loadingTags, setLoadingTags] = useState(true);
    const [courses, setCourses] = useState([]);
    const [loadingCourses, setLoadingCourses] = useState(true);

    const urlFile = `${API_BASE_URL}/admin/ContentFile/UploadFile`;
    const headersFile = {
        "accept": "*/*",
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + user.token
    };

    const taglist = useCallback(async () => {
        setLoadingTags(true);
        try {
            const activeTags = await getActiveTags(user.token);
            setTags(activeTags);
        } catch (err) {
            setMsg(err.message || "Etiket listesi yüklenirken hata oluştu.");
        } finally {
            setLoadingTags(false);
        }
    }, [user.token]);

    const courseList = useCallback(async () => {
        setLoadingCourses(true);
        try {
            const activeCourses = await getActiveCourses(user.token);
            setCourses(activeCourses);
        } catch (err) {
            setMsg(err.message);
        } finally {
            setLoadingCourses(false);
        }
    }, [user.token]);

    const executeAction = useCallback(async (payload) => {
        try {
            const res = await updateContent(payload, user.token);
            if (res.success) {
                Swal.fire({
                    title: "Başarılı!",
                    icon: "success",
                    confirmButtonText: `Soru listesi sayfasına Dön`,
                    timer: 500,
                }).then(() => {
                    window.location.reload();
                });
            } else {
                setMsg(res.message);
            }
        } catch (err) {
            setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
        }
    }, [user.token]);

    const updateQuestionMedia = useCallback((obj) => {
        executeAction({
            ...props.data,
            contentStr: JSON.stringify(obj)
        });
    }, [props.data, executeAction]);

    // 9 ayrı ama birebir aynı davranışlı fonksiyonun (addPhotoQuestion, handleQuestionPhotoChange,
    // handleQuestionPhotoChangeMulti, ... ) tek karşılığı: textarea/url veya dosya yüklemesini
    // işleyip sonucu buildObj callback'i ile soru medyasına yazar.
    const handleQuestionMediaChange = useCallback(async (e, mediaType, buildObj) => {
        if (e.target.type === "textarea") {
            updateQuestionMedia(buildObj(e.target.value));
        } else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const res = await axios({
                    method: 'Post',
                    url: urlFile,
                    params: { mediaType },
                    data: formData,
                    headers: headersFile
                });
                const uploadedUrl = API_ROOT + "/" + res.data['data']['path'];
                alert("Yüklendi");
                updateQuestionMedia(buildObj(uploadedUrl));
            } catch (err) {
                setMsg(err.message);
            }
        }
    }, [urlFile, headersFile, updateQuestionMedia]);

    const handleQuestion = useCallback((e) => {
        e.preventDefault();
        let questiontitle = document.getElementById("questionTitle").value.trim() || " ";
        let questiontext = document.getElementById("questionText").value.trim() || " ";
        const dataaa = JSON.parse(props.data.contentStr);
        dataaa['text'] = questiontitle + "__" + questiontext;
        executeAction({
            ...props.data,
            notfyText: document.getElementById("infoBoxText").value,
            contentStr: JSON.stringify(dataaa),
        });
    }, [props.data, executeAction]);

    return {
        msg, setMsg,
        tags, loadingTags, taglist,
        courses, loadingCourses, courseList,
        urlFile, headersFile,
        executeAction, updateQuestionMedia, handleQuestionMediaChange, handleQuestion
    };
};

export default useQuestionEditorShared;
